import React from "react";
import AppBrand from "../components/common/AppBrand";
import { useNavigate } from "react-router-dom";

const Error = ({ error, errorInfo, revokeError }) => {
  const navigate = useNavigate();
  const redirectToHome = () => {
    revokeError();
    navigate("/");
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="login-box">
            <div className="login_logo">
              <AppBrand className="app-brand--login" />
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ textAlign: "center" }}>
        <div className="row">
          <div className="span12">
            <div className="hero-unit center">
              <h1 style={{ color: "red" }}>
                <b>Something went wrong</b>
              </h1>
              <p style={{ fontSize: "20px" }}>
                <b>
                  Oops! Payment Box has encountered an error. Please try again
                  later.
                </b>
              </p>
              {/* {error && (
                <p>
                  Error {error.toString()} {errorInfo?.componentStack}
                </p>
              )} */}

              <button
                onClick={redirectToHome}
                className="btn btn-large btn-info not-found-home-btn"
              >
                <i className="icon-home icon-white"></i> Take Me Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
